export default "__VITE_ASSET__2f_7jo6u__"